var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9956 5.41941C11.4972 5.90901 16.398 11.0534 16.398 11.0534C16.525 11.176 16.626 11.3229 16.695 11.4853C16.764 11.6478 16.7996 11.8225 16.7996 11.999C16.7996 12.1755 16.764 12.3502 16.695 12.5127C16.626 12.6752 16.525 12.8221 16.398 12.9446C16.398 12.9446 11.4972 18.0914 10.9956 18.5786C10.494 19.0682 9.59155 19.1018 9.05756 18.5786C8.52236 18.0578 8.48036 17.3294 9.05756 16.6898L13.554 12.0002L9.05756 7.31061C8.48036 6.67101 8.52236 5.94141 9.05756 5.41941C9.59156 4.89621 10.494 4.92861 10.9956 5.41941Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d0ecc747832ed1b2f0b2d704c265fc0f.svg";
export { ForwardRef as ReactComponent };